import { Grid, Typography } from "@mui/material"
import React, { useMemo } from "react"
import { BSBuildingResult } from "../../../../../../../../../core/dto/beem-shot/BSBuildingResult/BSBuildingResult"
import { BSBuilding } from "../../../../../../../../../core/dto/beem-shot/BSBuilding/BSBuilding"
import { computeLabelIsRE2020 } from "../../../../../../../../../core/services/Dashboard/DashboardService"
import { displayDecimal } from "../../../../../../../../../core/services/helper-service"
import { IcConstructionThresholdChart } from "../../../../../../../../../components/charts/ThresholdChart/IcConstructionThresholdChart"

interface IProps {
  bsBuilding: BSBuilding | undefined
  bsBuildingResult: BSBuildingResult | undefined
  maxValue: number
}

export function BuildingThresholdRow({ bsBuilding, bsBuildingResult, maxValue }: Readonly<IProps>): React.JSX.Element {
  const labelIsRE20201: string = useMemo(
    () => (bsBuildingResult ? computeLabelIsRE2020(bsBuildingResult) : ""),
    [bsBuildingResult]
  )

  return bsBuilding && bsBuildingResult ? (
    <>
      <Grid item xs={3} sx={{ display: "flex", alignItems: "center" }}>
        <Typography>{bsBuilding.name}</Typography>
      </Grid>
      <Grid item xs={1} sx={{ display: "flex", alignItems: "center" }}>
        <Typography>{displayDecimal(bsBuildingResult.carbonImpactTotalPerSurface)}</Typography>
      </Grid>
      <Grid item xs={1} sx={{ display: "flex", alignItems: "center" }}>
        <Typography>{labelIsRE20201}</Typography>
      </Grid>
      <Grid item xs={7} sx={{ display: "flex", alignItems: "center" }}>
        <IcConstructionThresholdChart
          impact={bsBuildingResult.carbonImpactTotalPerSurface}
          threshold2022={bsBuildingResult.threshold2022}
          threshold2025={bsBuildingResult.threshold2025}
          threshold2028={bsBuildingResult.threshold2028}
          threshold2031={bsBuildingResult.threshold2031}
          maxValue={maxValue}
        />
      </Grid>
    </>
  ) : (
    <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
      <Typography>Il faut lancer le calcul de l'estimation sur ce bâtiment.</Typography>
    </Grid>
  )
}
